<script>

export default {
    name: 'courses-sort-button',

    emits: ['update-sort'],


    props : {
        label: {
            type: String,
            required : true
        },
        attr: {
            type: String,
            required : true
        }
    },
    data() {
        return {

        }
    },

    methods: {
        triggerSort() {
            console.log('click');
            this.$emit("update-sort", this.attr);
        }
    }
}

</script>

<template>
    <button class="course-sort-btn" type="button" @click="triggerSort">
        <span>{{label}}</span>
        <span class="svg-icon">
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.529356 5.41605H6.47064C6.69606 5.41605 6.85506 5.30288 6.94764 5.07654C7.04022 4.8502 7.01003 4.64198 6.85707 4.45185L3.88643 0.690123C3.83812 0.635802 3.78177 0.590535 3.71736 0.554321C3.65296 0.518107 3.58051 0.5 3.5 0.5C3.42754 0.5 3.3571 0.518107 3.28867 0.554321C3.22024 0.590535 3.16188 0.635802 3.11357 0.690123L0.14293 4.45185C-0.0100306 4.64198 -0.0402197 4.8502 0.0523618 5.07654C0.144943 5.30288 0.30394 5.41605 0.529356 5.41605ZM3.11357 11.3099C3.16188 11.3642 3.22024 11.4095 3.28867 11.4457C3.3571 11.4819 3.42754 11.5 3.5 11.5C3.57245 11.5 3.6429 11.4819 3.71133 11.4457C3.77976 11.4095 3.83812 11.3642 3.88643 11.3099L6.85707 7.54815C7.01003 7.35802 7.04022 7.1498 6.94764 6.92346C6.85506 6.69712 6.69606 6.58395 6.47064 6.58395H0.529356C0.30394 6.58395 0.144943 6.69712 0.0523618 6.92346C-0.0402197 7.1498 -0.0100306 7.35802 0.14293 7.54815L3.11357 11.3099Z" fill="#31343F"/>
            </svg>
        </span>
    </button>
</template>
